import "./style.css";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer-landing">
      <div className="footer-copyright">
        © prototype thesis.center is currently in closed alpha — beta coming soon.
      </div>
      <Link className="footer-credits-link" to="/credits">
        {t("credits-title")}
      </Link>
    </footer>
  );
}
